









import Vue from "vue";
import ModListUserEditCommentComp from "./ModListUserEditCommentComp.vue";
import ModListUserEditRoleComp from "./ModListUserEditRoleComp.vue";

export default Vue.extend({
	name: "ModListUserEditComp",
	components: { ModListUserEditCommentComp, ModListUserEditRoleComp },
	props: ["user"],
	methods: {
		commentUpdated: function(userId: number, comment: string): void {
			this.$emit("commentUpdated", userId, comment);
		}
	}
});
